import * as Constants from '../services/Constants'
import useUserContextRef from '../services/useUserContextRef'

export function useIsProUser() {
    const { userStateRef } = useUserContextRef()

    return Constants.proPolicies.includes(userStateRef.current.profile?.policy?._id ?? '')
}
